document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".itb_tab");
  const images = document.querySelectorAll(".tab-image");
  const imagesM = document.querySelectorAll(".tab-image-m");
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      images.forEach((img) => img.classList.remove("active"));
      imagesM.forEach((img) => img.classList.remove("active"));

      tab.classList.add("active");
      images[index].classList.add("active");
      imagesM[index].classList.add("active");
    });
  });
  tabs[0].classList.add("active");
});
